import { Brand } from './brand';

export type DayOfWeek = (typeof daysOfWeekValues)[number];
export const daysOfWeekValues = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export const defaultWorkingDays: DayOfWeek[] = ['mon', 'tue', 'wed', 'thu', 'fri'];

export const minuteValues = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55] as const;
export const hourValues = [0, 1, 2, 3, 4, 5, 6, 7, 8] as const;

export type StringYYYYMM = Brand<string, 'StringYYYYMM'>;
export type StringYYYYMMDD = Brand<string, 'StringYYYYMMDD'>;
export type StringYYYYMMDDHHmm = Brand<string, 'StringYYYYMMDDHHmm'>;
export type StringYYYYMMDDWithDashes = Brand<string, 'StringYYYYMMDDWithDashes'>;
export type StringHHmm = Brand<string, 'StringHHmm'>;
export type StringHHColonmm = Brand<string, 'StringHHColonmm'>;
